import { Component, OnInit } from "@angular/core"
import { Subscription } from "rxjs"
import { ModalConfig } from "../modal.model"
import { ModalService } from "../modal.service"
import { NgSwitchCase } from "@angular/common";

import { environment } from "../../../../environments/environment"
export let isDebugMode = environment.isDebugMode

@Component({
    selector: "flow-modal-message",
    templateUrl: "./modal-message.component.html",
    styleUrls: ["./modal-message.component.scss"]
})
export class ModalMessageComponent implements OnInit {

    subscriptions: Array<Subscription> = []
    modalConfig: ModalConfig = { opened: false }
    modalOpened: boolean = false
    flagDetails: boolean
    constructor(private modalService: ModalService) { }

    ngOnInit() {
        this.subscriptions.push(
            this.modalService.modalConfig.subscribe(config => {
                if (config.modal == 1) {
                    this.modalConfig = config
                    this.modalOpened = config.opened
                }
            })
        )
    }

    ngOnDestroy() {
        isDebugMode ? console.log(`ngOnDestroy()`) : undefined
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe()
        })
    }

    btnClick(button: number) {
        isDebugMode ? console.log(`btnClick()`) : undefined
        switch (button) {
            case 1: {
                this.btnDetails()
                break;
            }
            case 2: {
                this.btnOk()
                this.modalService.modalConfig.emit({ modal: 1, opened: false })
                break;
            }
            case 3: {
                this.btnYes()
                this.modalService.modalConfig.emit({ modal: 1, opened: false })
                break;
            }
            case 4: {
                this.btnNo()
                this.modalService.modalConfig.emit({ modal: 1, opened: false })
                break;
            }
            case 5: {
                this.btnClose()
                this.modalService.modalConfig.emit({ modal: 1, opened: false })
                break;
            }
            default: {
                this.modalService.modalConfig.emit({ modal: 1, opened: false })
                break;
            }
        }

        if (this.modalService.callback && (button == 2 || button == 3)) {
            this.modalService.callback()
        }



    }


    btnOk() {
        isDebugMode ? console.log(`OK()`) : undefined
    }

    btnYes() {
        isDebugMode ? console.log(`btn Yes`) : undefined
    }

    btnNo() {
        isDebugMode ? console.log(`btn NO`) : undefined
    }

    btnDetails() {
        isDebugMode ? console.log(`details()`) : undefined
        this.modalConfig.details = {}
        this.flagDetails = !this.flagDetails
    }

    btnClose() {
        isDebugMode ? console.log(`close()`) : undefined

    }

}